'use client';

import * as Styled from './GreetingSection.styled';
import GreetingHand from 'app/(authenticated)/_components/Icons/GreetingHand';

import { Alert } from '@capra/core';
import { Col, Row, Typography } from 'antd';
import * as React from 'react';

const { Text } = Typography;

interface GreetingSectionProps {
  userName?: string;
  canCreate: boolean;
  showAlert: boolean;
}

export const GreetingSection: React.FC<GreetingSectionProps> = ({
  userName,
  canCreate,
  showAlert,
}) => {
  const greetingAlert = (
    <Alert
      appearance='danger'
    >
      The email address you entered doesn't match our records. Please{' '}
      <a href='mailto:sales@cribl.io'>email sales</a> to get started with Cribl.Cloud Government.
    </Alert>);

  const greetingText = (
    <Text>Select an Organization {canCreate && 'or add a new one.'}</Text>);

  return (
    <Styled.GreetingContainer>
      <Col>
        <Styled.GreetingRow>
          <Styled.GreetingCol>
            <Col>
              <Styled.GreetingHand>
                <GreetingHand />
              </Styled.GreetingHand>
            </Col>
          </Styled.GreetingCol>

          <Col>
            <Row>
              <Styled.GreetingHeading>
                Hello {userName}!
              </Styled.GreetingHeading>
            </Row>
          </Col>
        </Styled.GreetingRow>
        <Row />

        <Styled.GreetingRow>{showAlert ? greetingAlert : greetingText}</Styled.GreetingRow>

      </Col>
    </Styled.GreetingContainer>
  );
};
